import {
    Navigation, Pagination, EffectCoverflow, Autoplay, Lazy,
} from 'swiper';

export const swiperConfigNova88 = {
    modules: [Navigation, Pagination, EffectCoverflow, Autoplay, Lazy],
    effect: 'coverflow',
    grabCursor: false,
    centeredSlides: true,
    lazy: true,
    preloadImages: false,
    slidesPerView: 'auto',
    coverflowEffect: {
        rotate: 332,
        stretch: 200,
        depth: 230,
        modifier: 1,
        scale: 0.9,
        slideShadows: true,
    },
    pagination: {
        el: '.promotions__swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.promotions__swiper-button-next',
        prevEl: '.promotions__swiper-button-prev',
    },
    loop: false,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    observer: true,
    observeParents: true,
};

export const swiperConfigBong88 = {
    modules: [Navigation, Pagination, EffectCoverflow, Autoplay, Lazy],
    effect: 'coverflow',
    grabCursor: false,
    centeredSlides: true,
    lazy: false,
    preloadImages: true,
    slidesPerView: 'auto',
    coverflowEffect: {
        rotate: 0,
        stretch: 350,
        depth: 300,
        modifier: 1,
        scale: 0.9,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.promotions__swiper-button-next',
        prevEl: '.promotions__swiper-button-prev',
        clickable: true,
    },

    loop: false,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    observer: true,
    observeParents: true,
    className: 'promotions',
};

export const swiperConfigViva88 = {
    modules: [Navigation, Pagination, EffectCoverflow, Autoplay, Lazy],
    effect: 'coverflow',
    grabCursor: false,
    centeredSlides: true,
    lazy: false,
    preloadImages: true,
    slidesPerView: 'auto',
    coverflowEffect: {
        rotate: 0,
        stretch: 350,
        depth: 300,
        modifier: 1,
        scale: 0.9,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.promotions__swiper-button-next',
        prevEl: '.promotions__swiper-button-prev',
        clickable: true,
    },

    loop: false,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    observer: true,
    observeParents: true,
    className: 'promotions',
    autoHeight: true,
};
